import React from 'react';

const SocialMediaButtons = ({}) => (
    <div className='social-media'>
        <a href='https://github.com/devjeetr/'><i className="fab fa-github"></i></a>
        <a href='https://github.com/devjeetr/' className='link'>github.com/devjeetr</a>
        <span><i className="fas fa-envelope"></i></span>
        <span>devjeet.roy@wsu.edu</span>
    </div>
)


export default SocialMediaButtons;